<template>
  <v-app>
    <v-content>
      <EtHeader />

      <EtWizard />
    </v-content>

    <EtSites />

    <EtFooter />
  </v-app>
</template>

<script>
import EtHeader from "./components/EtHeader";
import EtWizard from "./components/EtWizard";
import EtSites from "./components/EtSites";
import EtFooter from "./components/EtFooter";

export default {
  name: "App",
  components: {
    EtHeader,
    EtWizard,
    EtSites,
    EtFooter
  },
  data() {
    return {};
  }
};
</script>

<style>
.application--wrap {
  background: white;
}

.v-toolbar__title {
  color: white;
}

.wizard-header {
  padding-top: 0 !important;
}

img {
  display: block;
  width: auto;
  max-width: 100% !important;
}

.map-section {
  display: block;
  width: 100%;
  background: #fff;
  padding: 30px 15px 60px 15px;
}

.map {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.vue-form-wizard .wizard-tab-content {
  padding: 30px 20px !important;
}

.vue-form-wizard .wizard-title {
  font-size: 30px;
}

.vue-form-wizard .category {
  font-size: 16px;
}

.vue-form-wizard .wizard-icon {
  font-style: normal;
}

.v-list {
  padding: 0;
}

.v-list__tile__sub-title {
  white-space: normal;
}

.v-list__tile__avatar {
  min-width: 120px;
}

.v-avatar {
  width: 100px !important;
}

.v-avatar img {
  width: auto;
  height: auto;
  display: block;
  max-width: 100%;
  border-radius: 0 !important;
}

.v-list__tile--avatar img {
  padding: 15px;
}

.v-list__tile__content {
  padding: 15px;
}

.v-divider.v-divider--inset {
  width: 100%;
  margin-left: 0;
  max-width: 100%;
}

.v-list--two-line .v-list__tile {
  height: auto !important;
  min-height: 75px;
}

footer {
  z-index: 5;
}

footer img {
  margin: 0 auto 15px auto;
  display: block;
}

.wizard-icon-circle:focus {
  outline: none;
}

.vue-form-wizard.md .wizard-icon-circle {
  width: 60px !important;
  height: 60px !important;
  font-size: 21px !important;
}

.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
  top: 35px !important;
}

.vue-form-wizard .stepTitle {
  font-size: 16px;
}

.title {
  font-weight: 800;
  font-size: 20px;
  line-height: 1;
}

.v-btn {
  text-transform: capitalize;
  font-weight: bold;
  font-size: 16px;
}

.wizard-wrapper {
  background: #fff;
	padding: 15px;
}

.sites.wizard-wrapper {
	padding-bottom: 50px;
} 

@media screen and (min-width: 600px) {
  .v-list__tile .layout {
    flex-direction: row;
  }

  .title {
    font-size: 28px !important;
  }
}
</style>
